import { render, staticRenderFns } from "./CalendarTemplate.vue?vue&type=template&id=12f3c637&"
import script from "./CalendarTemplate.vue?vue&type=script&lang=ts&"
export * from "./CalendarTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports